import React from 'react';
import ChartistGraph from 'react-chartist';
import "./chartist.min.css";
import "./chart-custom-theme.css";
import {Card, CardTitle, Row} from "reactstrap";

class PlayerOverviewMinutesPlayedChart extends React.Component {
    render() {
        const minutesPlayedData = this.props.minutes_played_data;
        if (!minutesPlayedData) {
            return (
                <div className='chart-spinner-container'>
                    <i className='fa fa-spinner fa-spin'/>
                </div>
            );
        }
        const chartData = prepareChartData(minutesPlayedData);

        const data = {
            labels: chartData.dates,
            series: chartData.minutesPlayed
        };

        const options = {
            stackBars: true,
            low: 0
        };

        const type = 'Bar';

        return (
            <Card className="shadow rounded player-dashboard-card-height">
                <CardTitle className="my-0 py-0">
                    <Row className='mp-0 graph_title'><h5 className="ml-3">Minutes Played</h5></Row>
                    <ChartistGraph data={data} options={options} type={type}/>
                </CardTitle>
            </Card>
        )
    }
}

function prepareChartData(minutesPlayedData) {
    const minutesPlayed = [];
    const dates = [];
    const minutesPlayedWrap = [];
    for (let i = 0; i < minutesPlayedData.length; i++) {
        const currentData = minutesPlayedData[i];
        minutesPlayed.push(currentData['minutes_played']);
        dates.push(currentData['date'].substring(5));
    }

    minutesPlayedWrap.push(minutesPlayed);

    return {
        dates: dates,
        minutesPlayed: minutesPlayedWrap
    }
}

export default PlayerOverviewMinutesPlayedChart;



// WEBPACK FOOTER //
// ./src/components/components/player-overview-charts/player-overview-minutes-played-chart.js